export const publicUrls = {
  footerLanguageURL: '/mas/pub/getTeamsiteForeignLanguageLinks.json',
  helpCenterURL: '/mas/pub/getTeamsiteHelpCenterFaqsLinks.json',
  getProvidersURL: '/fps/public/searchProvider.json',
  getSDProvidersURL: '/mas/public/searchSDProvider.json',
  loginURL: '/EAI5/EAIProcessServlet',
  siteKeyURL: '/mas/pub/getUserSiteKeyDetails.json',
  forgotUsernameURL: '/mas/pub/findRegisteredMember',
  randomChallengesURL: '/mas/pub/randomChallenges.json',
  ebizURL: `https://webapp.carefirst.com/secure/eBizAdmin/member-admin/users/MemberSearchDisplay.do`,
  validateMemberProfileURL: '/CIAM2FA/validateMemberProfile',
  validateChallengeAndResponseURL: '/CIAM2FA/validateChallengeAndResponse',
  sendTokenURL: '/CIAM2FA/sendToken/',
  verifyTokenURL: '/CIAM2FA/verifyToken/',
  getSecurityQuestPublicURL: '/mas/pub/getSecurityQuestions.json',
  changeSecurityQuesPublicURL: '/mas/pub/changeSecurityQuestions.json',
  getPublicSecurityImageURL: '/mas/pub/getSiteKeyImages.json',
  updateSiteKeyDetailsPublicURL: '/mas/pub/updateUserSiteKeyDetails.json',
  outageURL: '/members/admin/outage-flag.page?_=',
  getTeamsiteContentPageLinksURL: '/mas/pub/getTeamsiteContentPageLinks.json',
  postValidateMemberRegistrationURL: '/mas/pub/validateMemberRegistration.json',
  postRegisterMemberURL: '/mas/pub/registerMember.json',
  validateIdentifierURL: '/mas/pub/decryptMemberRegistrationKey.json',
  findRegisteredMemberURL: '/mas/pub/findRegisteredMember.json',
  getSelfHelpInfoFromUserIdURL: '/mas/pub/getSelfHelpInfoFromUserIdandDob.json',
  sendUserNameToEmailAddressURL: '/mas/pub/sendUserNameToEmailAddress.json',
  sendUserNameToPhoneNumberURL: '/mas/pub/sendUserNameToPhone.json',
  getRandomChallengesURL: '/mas/pub/getRandomChallenges.json',
  validateRandomChallengeQuestionURL: '/mas/pub/validateRandomChallengeQuestion.json',
  validateChallengesURL: '/mas/pub/validateChallengeResponses.json',
  sendLoginInformationURL: '/mas/pub/sendLoginInformation.json',
  resetPasswordURL: '/mas/pub/resetPassword.json',
  changePasswordURL: '/mas/pub/changePassword.json',
  printClientExceptionLogsURL: 'pub/printClientExceptionLogs.json',
  updateMultifactorAuthURL: '/mas/mfa/updateMultifactorAuth.json',
  updateMFAStatus: '/mas/mfa/updateMFAStatus.json',
  getSecurityQuesURL: '/mas/mfa/getSecurityQuestions.json',
  emailConfirmURL: '/mas/pub/confirmEmailAddressEncrypted.json',
  consentUpdateURL: '/mas/pub/updateMemberConsent.json',
  changeUserLoginCredentialsUrl: '/mas/pub/changeUserLoginCredentials.json',
  shpWaiverDetailsUrl: '/mas/pub/getSHPWaiverDetails.json',
  submitSHPWaiverTransactionUrl: '/mas/pub/submitSHPWaiverTransaction.json',
  getCareSelectUnsecLink: '/mas/pub/getCareSelectUnsecLink.json' ,
  updateMemberCommunicationInfoURL: '/mas/pub/updateMemberEmailOrPhoneInfo.json',
  sendEmailSecurityTokenURL: '/mas/pub/sendEmailSecurityToken.json',
  verifyEmailSecurityTokenURL: '/mas/pub/verifyEmailSecurityToken.json',
  isUserIdAvailableForRegistrationURL: '/mas/pub/isUserIdAvailableForRegistration.json',
  sendMobilePhoneSecurityTokenURL: '/mas/pub/sendMobilePhoneSecurityToken.json',
  verifyMobilePhoneSecurityTokenURL: '/mas/pub/verifyMobilePhoneSecurityToken.json',
  getUserNameForMemberUrl: '/mas/pub/getUserNameForMember.json',
  resetPasswordWithAuthTokenUrl : '/mas/pub/resetPasswordWithAuthToken.json',
  newFindRegisteredMemberURL: '/mas/pub/findRegisteredMember.json',
  ibmSecurityLogout: '/mas/pub/ibm_security_logout',
};



// WEBPACK FOOTER //
// ./src/environments/urls/public-urls.ts